import { render, staticRenderFns } from "./CampaignListContent.vue?vue&type=template&id=488a23e2"
import script from "./CampaignListContent.vue?vue&type=script&lang=js"
export * from "./CampaignListContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports